import { render, staticRenderFns } from "./SectionLateral.vue?vue&type=template&id=f0400378&scoped=true&"
import script from "./SectionLateral.vue?vue&type=script&lang=js&"
export * from "./SectionLateral.vue?vue&type=script&lang=js&"
import style0 from "./SectionLateral.vue?vue&type=style&index=0&id=f0400378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0400378",
  null
  
)

export default component.exports